// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1rjai","container":"styles_container__3Svoh","title":"styles_title__TWh8L","wrapper":"styles_wrapper__3jAJh","answer":"styles_answer__KSMvR"};